var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRcsBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12865 0.374212C5.03039 0.127307 6.96938 0 8.93776 0C10.9059 0 12.8447 0.127281 14.7463 0.374138C16.5084 0.602885 17.7635 2.08026 17.8679 3.79037C17.5693 3.69063 17.2528 3.62447 16.9217 3.59699C15.6488 3.49134 14.3617 3.4375 13.0625 3.4375C11.7632 3.4375 10.4761 3.49134 9.20332 3.59698C7.04156 3.7764 5.5 5.60511 5.5 7.66169V11.5901C5.5 13.1398 6.37512 14.5591 7.73007 15.2422L5.29864 17.6736C5.10201 17.8703 4.80631 17.9291 4.54941 17.8227C4.2925 17.7163 4.125 17.4656 4.125 17.1875V13.4938C3.79178 13.4581 3.45966 13.4188 3.12866 13.3758C1.28761 13.1368 0 11.5347 0 9.72825V4.02177C0 2.21533 1.2876 0.613236 3.12865 0.374212Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 4.8125C11.8013 4.8125 10.5521 4.86477 9.31705 4.96727C7.90603 5.08438 6.875 6.28175 6.875 7.66169V11.5901C6.875 12.9721 7.90897 14.1701 9.32177 14.2855C10.462 14.3785 11.6142 14.4294 12.7768 14.4366L15.3264 16.9861C15.523 17.1828 15.8187 17.2416 16.0756 17.1352C16.3325 17.0288 16.5 16.7781 16.5 16.5V14.3093C16.6011 14.3017 16.7022 14.2938 16.8032 14.2855C18.216 14.1702 19.25 12.9722 19.25 11.5901V7.6617C19.25 6.28176 18.219 5.08439 16.808 4.96728C15.5729 4.86477 14.3237 4.8125 13.0625 4.8125Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcsBot);
export default __webpack_public_path__ + "static/media/rcs_bot.d10aec748f9699ae0b8a38165d407ef9.svg";
export { ForwardRef as ReactComponent };